// @ts-strict-ignore
import { Component, OnInit } from "@angular/core";
import { AbstractFlatWidget } from "src/app/shared/components/flat/abstract-flat-widget";
import { Modal } from "src/app/shared/components/flat/flat";
import { ChannelAddress, Currency, CurrentData, EdgeConfig, Utils } from "src/app/shared/shared";

import { ModalComponent } from "../modal/modal";

@Component({
    selector: "timeOfUseTariffPrice",
    templateUrl: "./flat.html",
    standalone: false,
})
export class FlatComponent extends AbstractFlatWidget implements OnInit {

    protected consumptionPriceWithCurrency: string = "-";
    protected productionPriceWithCurrency: string = "-";


    protected modalComponent: Modal | null = null;

    protected override afterIsInitialized(): void {
        this.modalComponent = this.getModalComponent();
    }

    protected getModalComponent(): Modal {
        return {
            component: ModalComponent,
            componentProps: {
                component: this.component,
            },
        };
    };

    protected override getChannelAddresses(): ChannelAddress[] {
      return [
        new ChannelAddress(this.component.id, "QuarterlyConsumptionPrices"),
        new ChannelAddress(this.component.id, "QuarterlyProductionPrices"),
      ];
    }

    protected override onCurrentData(currentData: CurrentData): void {
      const quarterlyConsumptionPrice = currentData.allComponents[this.component.id + "/QuarterlyConsumptionPrices"];
      const quarterlyProductionPrice = currentData.allComponents[this.component.id + "/QuarterlyProductionPrices"];
      const meta: EdgeConfig.Component = this.config?.getComponent("_meta");
      const currency: string = this.config?.getPropertyFromComponent<string>(meta, "currency");
      const currencyLabel: Currency.Label = Currency.getCurrencyLabelByCurrency(currency);
      this.consumptionPriceWithCurrency = this.Utils.CONVERT_PRICE_TO_CENT_PER_KWH(2, currencyLabel)(quarterlyConsumptionPrice);
      this.productionPriceWithCurrency = this.Utils.CONVERT_PRICE_TO_CENT_PER_KWH(2, currencyLabel)(quarterlyProductionPrice);
    }
}
